import { render, staticRenderFns } from "./TiposOSLista.vue?vue&type=template&id=2f11674f&scoped=true&"
import script from "./TiposOSLista.vue?vue&type=script&lang=js&"
export * from "./TiposOSLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f11674f",
  null
  
)

export default component.exports